// extracted by mini-css-extract-plugin
module.exports = {"cards":"Cards_cards__3vslv"};